import React from 'react';

const ProfileLink = ({ children, onClick, compact = false }) => {
  if (compact) {
    return (
      <div
        role="button"
        tabIndex={0}
        onClick={onClick}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onClick();
          }
        }}
        className="glass-card inline-flex items-center gap-2 py-2 px-3 rounded-md text-sm text-ink cursor-pointer border border-line transition-colors duration-200 hover:border-accent"
      >
        {children}
      </div>
    );
  }

  return (
    <div
      onClick={onClick}
      className="glass-card p-4 rounded-lg text-center cursor-pointer transform transition-transform duration-300 hover:-translate-y-2"
    >
      {children}
    </div>
  );
};

export default ProfileLink;
